import React from 'react';
import { FadeIn } from './FadeIn';
import { Clock } from 'lucide-react';
export function ProofSection() {
  return <section className="py-20 md:py-28 bg-brand-gold/10" data-id="element-151">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-152">
        <FadeIn data-id="element-153">
          <div className="inline-flex items-center justify-center p-4 bg-white rounded-full shadow-sm mb-8 text-brand-gold" data-id="element-154">
            <Clock className="w-8 h-8" data-id="element-155" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-brand-charcoal mb-8" data-id="element-156">
            Lo que cambia en 7 días
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-157">
          <p className="text-xl md:text-2xl text-brand-charcoal/80 leading-relaxed font-serif italic" data-id="element-158">
            "Dejarás de reaccionar a las notificaciones para empezar a dictar el
            ritmo de tu trabajo. Tus clientes notarán la diferencia en la
            calidad de tus entregables y tú notarás la diferencia en tu cuenta
            bancaria al eliminar el trabajo improductivo que hoy haces gratis."
          </p>
        </FadeIn>
      </div>
    </section>;
}